import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PageHeader from '../../components/page/PageHeader';
import { update_page_meta } from '../../actions/page/header';
import { connect } from 'react-redux';
import QRCodeGenerator from '../../components/QRCodeGenerator';
import PrintLabel from '../../components/PrintLabel';
import axios from 'axios';
import { JSON_CONTENT_FORM_CONFIG } from '../../actions/Config';
import { useSearchParams } from 'react-router-dom';
import { getJSONContentFormConfig } from '../../actions/Config';
import { useNavigate } from 'react-router-dom';
import { HomePageURL } from '../../assets/const';



const CustomForm = ({customSize, setCustomSize, form, setForm, selectedProductTemplate}) => {
    
    const handleChange = (e) => {
        const elem = e.currentTarget;
        setCustomSize(prevSize => ({ ...prevSize, [elem.name]: elem.value }));
    }
    const [loading, setLoading] = useState(false);
    const onsubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setLoading(true);
        try{
            const data = JSON.stringify({
                length: customSize.length,
                width: customSize.width,
                thickness: customSize.thickness,
                mrp: customSize.mrp,
            })
            const jsonConfig = getJSONContentFormConfig();
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/catalog/create-custom-variant/${selectedProductTemplate?.slug}/`, data, jsonConfig);
            if (res.status === 200){
                setForm({...form, product: res.data.variant})
            }
        }
        catch{}
        setLoading(false);
    }
    return (
        <div style={{border: "1px solid #3b3f5c", borderRadius: "10px", padding: "10px"}} className='mt-2 mb-2'>
            <h5>Create a custom sized product</h5>
            <div className="form-group">
                <label for="customLengthInput">Length in Inches</label>
                <input type="number" onChange={handleChange} className="form-control" id="customLengthInput" aria-describedby="customLengthInputHelp" placeholder="Enter length of the product" value={customSize.length} name="length" required />
                <small id="customLengthInputHelp" className="form-text text-muted">Enter length of the product</small>
            </div>
            <div className="form-group mt-2">
                <label for="customWidthInput">Width in Inches</label>
                <input type="number" onChange={handleChange} className="form-control" id="customWidthInput" aria-describedby="customWidthInputHelp" placeholder="Enter width of the product" value={customSize.width} name="width" required />
                <small id="customWidthInputHelp" className="form-text text-muted">Enter width of the product</small>
            </div>
            <div className="form-group mt-2">
                <label for="customThicknessInput">Thickness in Inches</label>
                <input type="number" onChange={handleChange} className="form-control" id="customThicknessInput" aria-describedby="customThicknessInputHelp" placeholder="Enter thickness of the product" value={customSize.thickness} name="thickness" required />
                <small id="customThicknessInputHelp" className="form-text text-muted">Enter thickness of the product</small>
            </div>
            <div className="form-group mt-2">
                <label for="customMRPInput">MRP in Rupees</label>
                <input type="number" onChange={handleChange} className="form-control" id="customMRPInput" aria-describedby="customMRPInputHelp" placeholder="Enter MRP of the product" value={customSize.mrp} name="mrp" required />
                <small id="customMRPInputHelp" className="form-text text-muted">Enter MRP of the product</small>
            </div>
            <button className='btn btn-primary' onClick={onsubmit} disabled={loading}>Create</button>
        </div>
        
    )
}

const FGList = ({ update_page_meta }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    update_page_meta({
        title: "Finished Goods",
        description: "List with QR codes of finished goods"
    });
    const [form, setForm] = useState({
        show: false,
        product: null,
        count: null
    })
    const [searchTerm, setSearchTerm] = useState('');
    const [autoComplete, setAutoComplete] = useState([]);
    const [selectedProductTemplate, setSelectedProductTemplate] = useState(null);
    const [availableConfigurations, setAvailableConfigurations] = useState([]);
    const [selectedConfigurations, setSelectedConfigurations] = useState([]);
    const [customSize, setCustomSize] = useState({
        custom: false,
        length: null,
        width: null,
        thickness: null,
        mrp: null,
    })
    const [qrCodes, setQrCodes] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [fetching, setFetching] = useState(false);
    const [printingProgress, setPrintingProgress] = useState(false);
    const bottomElementRef = useRef();
    useEffect(() => {
        const fetchMore = async () => {
          if (page > totalPages || fetching) return;
          try {
            setFetching(true);
            let params = `page=${page}&page_size=${pageSize}`;
            if (searchParams.get('product'))
                params += `&product=${searchParams.get('product')}`;
            if (searchParams.get('status'))
                params += `&status=${searchParams.get('status')}`;
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/finished-goods/list/?${params}`, JSON_CONTENT_FORM_CONFIG);
            if (response.status === 200) {
                setQrCodes((prevItems) => {
                    if (page === 1) {
                        return response.data.results; // Set the initial orders
                    } else {
                        return [...prevItems, ...response.data.results]; // Append new orders
                    }
                });
                setTotalPages(response.data.num_pages);
                setPage(page + 1);
            }
          } catch (error) {
            console.error("Error fetching more products:", error);
          } finally {
            setFetching(false);
          }
        };
        const options = {
          root: null, // viewport
          rootMargin: "0px",
          threshold: 0.1, // When 10% of the element is visible, trigger the callback
        };
    
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            fetchMore();
          }
        }, options);
  
        const bottomElement = bottomElementRef.current;
    
        if (bottomElement) {
          observer.observe(bottomElement);
        }
    
        return () => {
          if (bottomElement) {
            observer.unobserve(bottomElement);
          }
        };
      }, [bottomElementRef, page, totalPages, fetching]);
    useEffect(() => {
        const fetch = async () => {
            try{
                const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/catalog/search/?q=${searchTerm}`, JSON_CONTENT_FORM_CONFIG);
                if (res.status === 200){
                    setAutoComplete(res.data.products)
                }
            }
            catch{
                return {
                    success: false
                }
            }
        }
        if (searchTerm.length > 0) fetch();
        else {
            setForm({...form, product: null})
            setAutoComplete([]);
        }
    }, [searchTerm]);
    const [isRowSelected, setIsRowSelected] = useState(false);
    const rowSelected = (e) => {
        let el = e.currentTarget;
        if (el.checked) setIsRowSelected(true);
        else{
            let tr = el.closest('tr')
            tr.style.backgroundColor = '';
            // all_els = document.getElementsByName('selected_to_print');
            let isAnySelected = Array.from(document.querySelectorAll('[name=selected_to_print]')).some(x => x.checked);
            if (isAnySelected) setIsRowSelected(true);
            else setIsRowSelected(false);
        }
    }
    const printQR = (selectedRows) => {
        const printData = selectedRows.map(qrContainer => {
            const qrCodeSrc = qrContainer.dataset.code;
            const logoSrc=`${process.env.REACT_APP_BASE_URL}/static/assets/images/logo.webp`;
            const productName = qrContainer.dataset.productName;
            const mrp = qrContainer.dataset.mrp;
            const dateOfMfg = qrContainer.dataset.dateOfMfg;
            return {qrCodeSrc, logoSrc, productName, mrp, dateOfMfg}
        })
        
        
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        // Set the content of the iframe to be your print preview HTML
        const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(`
            <html>
                <head>
                    <title>Print Preview</title>
                    <style>
                        @page {
                            width: 100mm;
                            height: 50mm;
                            margin: 0;
                            padding: 0;
                        }
                        body {
                            font-family: Arial, sans-serif;
                            margin: 0;
                            padding: 0;
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                        }
                        .print-item {
                            width: 100mm;
                            height: 50mm;
                            margin: 0;
                            padding: 0;
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                            /*box-sizing: border-box;*/
                            /*page-break-after: always;*/ /* Force page break after each item */
                        }
                    </style>
                </head>
                <body>
                    <div id="print-content"></div>
                </body>
            </html>
        `);
        iframeDocument.close();

        iframe.onload = () => {
            const printContainer = iframeDocument.getElementById('print-content');
            ReactDOM.render(printData.map(item => {return <div className="print-item"><PrintLabel qrCodeSrc={item.qrCodeSrc} productName={item.productName} mrp={item.mrp} logoSrc={item.logoSrc} dateOfMfg={item.dateOfMfg} /></div>}), printContainer);
            const imagesAndCanvas = Array.from(printContainer.querySelectorAll('img, canvas'));

            const waitForCanvasLoad = (canvas) => {
                return new Promise((resolve, reject) => {
                    const context = canvas.getContext('2d', { willReadFrequently: true });
                    if (!context) {
                        reject('Canvas context unavailable');
                        return;
                    }
            
                    const checkLoad = () => {
                        
                        if (context.canvas.width > 0 && context.canvas.height > 0) {
                            resolve();
                        } else {
                            setTimeout(checkLoad, 100); // Check again after a short delay
                        }
                        
                    };
                    setTimeout(checkLoad, 500); // Giving an initial delay of 500ms to check whether the canvas is loaded
                });
            };
            
            const loadPromises = imagesAndCanvas.map((element) => {
                if (element.tagName === 'IMG' && !element.complete) {
                    return new Promise((resolve, reject) => {
                        element.addEventListener('load', () => {
                            resolve();
                        });
                    });
                } else if (element.tagName === 'CANVAS') {
                    return waitForCanvasLoad(element);
                } else {
                    return Promise.resolve(); // For other elements, resolve immediately
                }
            });
            
            Promise.all(loadPromises).then(() => {
                // All images and canvases are loaded
                iframe.contentWindow.print();
                // iframe.contentWindow.onafterprint = () => {
                //     document.body.removeChild(iframe);
                // };
            }).catch((error) => {
                console.error('Error loading images and canvases:', error);
            });
        };

        
        // const onFocus = () => {
        //     iframe.remove()
        //     window.removeEventListener("focus", onFocus)
        // }
        // window.addEventListener("focus", onFocus)
    }
    const printSelected = async (e) => {
        if (printingProgress) return;
        setPrintingProgress(true);
        let selectedCheckboxes = Array.from(document.querySelectorAll('[name=selected_to_print]')).filter(x => x.checked);
        let selectedProductIds = selectedCheckboxes.map(el => {
            let qrContainer = el.closest('tr');
            return qrContainer.dataset.id;
        });
        const products = JSON.stringify({
            products: selectedProductIds
        });
        try{
            const jsonConfig = getJSONContentFormConfig();
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/finished-goods/print-bulk/`, products, jsonConfig);
            if (res.status !== 200) {setPrintingProgress(false); return;}
            const selectedRows = Array.from(document.querySelectorAll('[name=selected_to_print]:checked')).map(el => el.closest('tr'));
            printQR(selectedRows);
        }
        catch(err){
            if (err.response.status === 409){
                window.alert(err.response.data.error);
                let array = err.response.data.affected_products || [];
                console.log(array);
                array.forEach(id => {
                    console.log(id);
                    document.querySelectorAll('tr').forEach(tr => {
                        let dataId = tr.getAttribute('data-id');
                        if (dataId) dataId = parseInt(dataId);
                        if (dataId === id) {
                            // Add a red background color to the matching 'tr' element
                            tr.style.backgroundColor = 'red';
                        }
                    });
                });
                setPrintingProgress(false); return;
            }
            else{
                setPrintingProgress(false); return;
            }
        }
        setPrintingProgress(false);
    }
    
    const createQR = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (form.product && form.count && form.count > 0){
            const data = {
                product: form.product.slug,
                count: form.count
            }
            try{
                const jsonConfig = getJSONContentFormConfig();
                const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/finished-goods/create/`, data, jsonConfig);
                if (res.status === 200){
                    setQrCodes([...res.data, ...qrCodes]);
                    setForm({show: false, product: null, count: null});
                    setSearchTerm('');
                    setAutoComplete([]);
                    setSelectedProductTemplate(null);
                    setAvailableConfigurations([]);
                    setSelectedConfigurations([]);
                }
            }
            catch{}
        }
        else {
            return;
        }
    }
    const selectProductTemplate = (item) => {
        setSelectedProductTemplate(item)
    }
    useEffect(() => {
        const fetchConfigurations = async () => {
            try{
                const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/catalog/available-configurations/${selectedProductTemplate?.slug}/`, JSON_CONTENT_FORM_CONFIG);
                if (res.status === 200){
                    setAvailableConfigurations(res.data.configurations)
                }
            }
            catch{}
        }
        if (selectedProductTemplate) fetchConfigurations()
    }, [selectedProductTemplate]);
    const selectConfiguration = (e) => {
        let li = e.currentTarget;
        let ul = li.closest('ul');
        const optionId = li.dataset.id;
        const configurationId = ul.dataset.id;
        const configurations = [...selectedConfigurations]; // Create a new array
    
        let conf = configurations.find(item => item.configurationId === configurationId);
        if (conf) {
            let index = configurations.indexOf(conf);
            conf.optionId = optionId;
            configurations.splice(index, 1, conf);
        } else {
            configurations.push({ configurationId: configurationId, optionId: optionId });
        }
        setSelectedConfigurations([...configurations]);
    }
    useEffect(() => {
        const fetchVariant = async () => {
            const optionIds = selectedConfigurations.map(item => item.optionId);
            try{
                const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/catalog/get-variant/${selectedProductTemplate?.slug}/?configurations=${JSON.stringify(optionIds)}`, JSON_CONTENT_FORM_CONFIG);
                if (res.status === 200){
                    setForm({...form, product: res.data.variant})
                }
            }
            catch{}
        }
        if (selectedProductTemplate && selectedConfigurations.length === availableConfigurations.length){
            fetchVariant();
        }
    }, [selectedConfigurations]);
    
  return (
    <>
        <PageHeader title="Finished Goods" />
        <div className="row layout-top-spacing" id="cancel-row">
            {form.show && 
            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                <div className="widget-content widget-content-area br-6">
                    <div className='d-flex' style={{alignContent: "center", alignItems: "center", justifyContent: "center", maxWidth: "640px", margin: "auto"}}>
                        <form onSubmit={createQR} style={{width: "100%"}}>
                            {form.product ? 
                            <>
                                <span>{form.product?.display_name} &nbsp; <span onClick={() => {setForm({...form, product: null}); setSelectedConfigurations([]);}} style={{color: "blue", cursor: "pointer"}}>Change?</span></span>
                                <div className="form-group mt-2">
                                    <label for="unitCountInput">Number of units produced</label>
                                    <input type="number" onChange={(e) => {setForm({...form, count: e.currentTarget.value})}} className="form-control" id="unitCountInput" aria-describedby="unitCountInputHelp" placeholder="Enter number of units produced" value={form.count} required />
                                    <small id="unitCountInputHelp" className="form-text text-muted">Enter number of units produced</small>
                                </div>
                            </>
                            :
                            <>
                                {selectedProductTemplate ?
                                    <>
                                        <span>{selectedProductTemplate?.name} &nbsp; <span style={{color: "blue", cursor: "pointer"}} onClick={() => setSelectedProductTemplate(null)}>Change?</span></span>    
                                        
                                        {customSize.custom ? 
                                        <>
                                            <div className='mt-2'>
                                                <span style={{color: "blue", cursor: "pointer", transform: "scale(1.3)"}} onClick={() => setCustomSize({...customSize, custom: false})}>Show all available standard sizes.</span>
                                            </div>
                                            {/* Ensure that the setCustomSize prop is passed correctly as a function */}
                                            <CustomForm customSize={customSize} setCustomSize={setCustomSize} form={form} setForm={setForm} selectedProductTemplate={selectedProductTemplate} />
                                        </>
                                        : <>
                                            <div className='mt-2'>
                                                <span style={{color: "blue", cursor: "pointer", transform: "scale(1.3)"}} onClick={() => setCustomSize({...customSize, custom: true})}>Click here if you are creating a custom sized product.</span>
                                            </div>
                                            {availableConfigurations.length > 0 ? 
                                                <div className=''>
                                                    {availableConfigurations.map((item, index) => {
                                                        return (
                                                            <div key={index}>
                                                                <h6 className='mt-2'>{item.name}</h6>
                                                                <ul key={item.id} className='' data-id={item.id} style={{ listStyle: "none", margin: 0, padding: 0, display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px" }}>
                                                                    {item.options.map((option, i) => {
                                                                        return (
                                                                            <li key={i} onClick={selectConfiguration} data-id={option.id} 
                                                                                style={{ padding: "3px 8px", cursor: "pointer", border: "0.4px solid", borderRadius: "10px", backgroundColor: selectedConfigurations.find((item) => parseInt(item.optionId) === parseInt(option.id)) ? "blue" : "transparent", color: selectedConfigurations.find((item) => parseInt(item.optionId) === parseInt(option.id)) ? "white" : "black"}}>{option.option}</li>
                                                                        )
                                                                    })}
                                                                </ul>
                                                            </div>
                                                        )
                                                    })}
                                                </div> 
                                            : <i className='fa fa-truck-loading' />}
                                            </>}
                                    </>
                                    :
                                    <div className="form-group" style={{position: "relative"}}>
                                        <label for="productSelectionInput">Select Product</label>
                                        <input type="text" className="form-control" value={searchTerm} onChange={(e) => setSearchTerm(e.currentTarget.value)} id="productSelectionInput" aria-describedby="productSelectionInputHelp" placeholder="Start typing the product name" />
                                        <small id="productSelectionInputHelp" className="form-text text-muted">Start typing the product name</small>
                                        {autoComplete.length > 0 && 
                                        <div className='p-2 bg-white' style={{position: "absolute", border: "1px solid", width: "100%", zIndex: 1}}>
                                            <ul className='' style={{listStyle: "none", padding: 0}}>
                                                {autoComplete.map((item, index) => {
                                                    return (
                                                        <li key={index} style={{cursor: "pointer", color: "blue", fontWeight: "600", paddingTop: "5px"}} onClick={() => selectProductTemplate(item)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-log-out"><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                                                            &nbsp;{item.name}</li>
                                                    )
                                                })}
                                            </ul>
                                        </div>}
                                    </div>}
                            </>
                            }
                            <div className='d-flex mt-2'>
                                <button onClick={() => setForm({...form, show: false})} className="btn btn-secondary">Cancel</button>
                                {form.product && <button type="submit" className="btn btn-primary ms-2">Create</button>}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            }
            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                <div className="widget-content widget-content-area br-6">
                    {!form.show &&
                    <button className="btn btn-primary" onClick={() => setForm({...form, show: true})}>Generate QR Code</button>}
                    <button className="btn btn-primary ms-3" onClick={() => navigate(`${HomePageURL}/fg/bundles/`, { replace: false })}>Product Bundles</button>
                    {isRowSelected &&
                    <button className="btn btn-primary ms-3" onClick={printSelected}>Print Selected</button>}
                    
                    <div className="table-responsive mb-4 mt-4">
                        <table id="zero-config" className="table table-hover" style={{width: "100%"}}>
                            <thead>
                                <tr>
                                    <th className="no-content"></th>
                                    <th>QR Code</th>
                                    <th>Product</th>
                                    <th>Manufactured on</th>
                                    <th>Status</th>
                                    <th>Lot ID</th>
                                    <th className="no-content"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    qrCodes?.map((item) => {
                                        return (
                                            <tr key={item?.id} data-code={item?.code} data-id={item.id} data-product-name={item?.product?.display_name}
                                            data-mrp={item?.product?.base_price}
                                            data-date-of-mfg={item?.manufacturing_date}>
                                                <td><input type='checkbox' onChange={rowSelected} name='selected_to_print' /></td>
                                                <td>
                                                    <span><QRCodeGenerator value={item?.code} size={64} /></span></td>
                                                <td>{item?.product?.display_name}</td>
                                                <td>{item?.manufacturing_date}</td>
                                                <td>{item?.status}</td>
                                                <td>{item?.lot_id}</td>
                                                <td>
                                                    {/* <button className='btn btn-primary' onClick={printQR}>Print Price Slip</button> */}
                                                    {/* <Link to={`${HomePageURL}/fg/${item?.id}/`}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                                                    </Link> */}
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                            <tfoot ref={bottomElementRef}></tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default connect(null, {update_page_meta}) (FGList);